<div class="as-modal-container">
    <p class="as-font as-font-18">{{ 'AUTH.welcome' | translate }}</p>
    <div class="btn-container">
        <button mat-flat-button color="accent" (click)="closeModal()">Continuar</button>
    </div>
</div>